export enum ApiResultCode {
     Ok							= 'Ok',
 
     ResultCodeNotProvided		= 'ResultCodeNotProvided',
     FileNotFound				= 'FileNotFound',
 
     UnauhtorizedUser			= 'UnauhtorizedUser',		// L'utilisateur n'est pas authentifié (mal fichu: AuthorizedAttribute ne renvoie que ça)
     AccessForbidden				= 'AccessForbidden',		// L'utilisateur est authentifié mais il n'a pas le droit d'accéder à la ressource demandée
     UnauthorizedMethod			= 'UnauthorizedMethod',
     
 
     InvalidModelState			= 'InvalidModelState',
         
     InternalException			= 'InternalException',
 }